import { CaretDownOutlined, CaretUpOutlined, PlusOutlined } from '@ant-design/icons';
import { Access } from '@prisma/client';
import { Button } from 'antd';

import { SourceAccessItem } from '@app/domain-access-interfaces';

import { isAccessEqual } from '../../common';
import { Dependency } from '../forms/use-bundle-form';

export const DependencyRenderer = ({
  accessDependencies,
  record,
  onClick,
}: {
  accessDependencies: Dependency[];
  record: SourceAccessItem | Access;
  onClick?: () => void;
}) => {
  const parents = accessDependencies.filter((x) => isAccessEqual(x.child, record)).length;
  const children = accessDependencies.filter((x) => isAccessEqual(x.parent, record)).length;

  const parentsTitle = parents ? `${parents} Parent${parents !== 1 ? 's' : ''}` : '';
  const childrenTitle = children ? `${children} Child${children !== 1 ? 'ren' : ''}` : '';

  return (
    <Button
      icon={!parents && !children && <PlusOutlined />}
      title={`${parentsTitle} ${childrenTitle}`.trim()}
      onClick={onClick}
      size="small"
    >
      {parents || children ? (
        <>
          <span style={{ paddingRight: '0.5em' }}>
            <CaretUpOutlined />
            {parents}
          </span>
          <span>
            <CaretDownOutlined />
            {children}
          </span>
        </>
      ) : (
        'Add'
      )}
    </Button>
  );
};
